import * as tslib_1 from "tslib";
/* tslint:disable:forbid-import */
import { orchestratorAction } from 'satcheljs';
/* tslint:enable:forbid-import */
import { getStore } from '../store/store';
import updateCategory from '../orchestrators/updateCategory';
export default orchestratorAction('selectSubcategory', function selectSubcategory(subcategory) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var store;
        return tslib_1.__generator(this, function (_a) {
            store = getStore();
            updateCategory(store.currentCategoryKey, subcategory.key, null);
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=selectSubcategory.js.map